import styled from "styled-components";
import { COLORS } from "../../../../styles/constants.style";

export const SortIconWrapper = styled.div`
  .table-header-icon {
    color: ${COLORS.primary_light_blue};
  }
  .swap-icon {
    transform: scaleY(-1.2);
  }
`;
